import React from 'react';
import { Typography, Link, Breadcrumbs } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Breadcrumbs Navigation Component
 */
const StyledBreadcrumbs = styled(motion(Breadcrumbs))(({ theme }) => ({
  padding: `${theme.spacing(2)} 0`,
  fontSize: '0.95rem',
  
  '& .MuiBreadcrumbs-li': {
    display: 'flex',
    alignItems: 'center',
  },
}));

const BreadcrumbLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  textDecoration: 'none',
  transition: 'all 0.3s ease-in-out',
  fontWeight: 500,
  
  '&:hover': {
    color: theme.palette.primary.light,
    textDecoration: 'underline',
  },
}));

const BreadcrumbsNavigation = ({ items = [] }) => {
  return (
    <StyledBreadcrumbs
      separator={<NavigateNext fontSize="small" />}
      aria-label="breadcrumb"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.href ? (
            <BreadcrumbLink component={RouterLink} to={item.href}>
              {item.label}
            </BreadcrumbLink>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
              {item.label}
            </Typography>
          )}
        </React.Fragment>
      ))}
    </StyledBreadcrumbs>
  );
};

export default BreadcrumbsNavigation;
